const REQUIRED_MARKER_SELECTOR = '[data-required="true"]'

const isPlainFieldAnswered = el => {
	if (!el) return true
	if (el.tagName === 'SELECT') return !!el.value
	if (el.tagName === 'INPUT' && (el.type === 'checkbox' || el.type === 'radio')) return el.checked
	return !!(el.value && el.value.trim())
}

const GROUP_BUTTON_SELECTOR =
	'.yesno-btn, .btn-toggle, .btn-toggle-i, .btn-toggle-j, .type-card, .review-toggle-btn'
const FIELD_CONTAINER_SELECTOR =
	'.input-group, .section-c-question-container, .dependent-card, .load-card, .obligation-card, .form-grid-assets, .costs-grid, .asset-card'

const resolveField = marker => {
	const label = marker.closest('label')
	if (label && label.htmlFor) {
		const byId = document.getElementById(label.htmlFor)
		if (byId) return byId
	}

	const container = marker.closest(FIELD_CONTAINER_SELECTOR) || marker.closest('.section-card')
	if (!container) return null

	const customSelect = container.querySelector('.custom-select-trigger')
	if (customSelect) return customSelect

	const groupButtons = container.querySelectorAll(GROUP_BUTTON_SELECTOR)
	if (groupButtons.length > 0) return groupButtons[0]

	return container.querySelector('input, textarea, select')
}

const isFieldAnswered = field => {
	if (!field) return true
	if (field.classList.contains('custom-select-trigger')) {
		return !field.classList.contains('placeholder')
	}
	if (field.matches(GROUP_BUTTON_SELECTOR)) {
		const group = field.closest(FIELD_CONTAINER_SELECTOR) || field.parentElement
		const buttons = group.querySelectorAll(GROUP_BUTTON_SELECTOR)
		return Array.from(buttons).some(
			b => b.classList.contains('selected') || b.classList.contains('active')
		)
	}
	return isPlainFieldAnswered(field)
}

export const getRequiredFieldStatus = container => {
	const root = container || document.querySelector('.section-card')
	if (!root) return { total: 0, missing: 0, firstMissingEl: null }

	const markers = Array.from(root.querySelectorAll(REQUIRED_MARKER_SELECTOR))
	const seen = new Set()
	let total = 0
	let missing = 0
	let firstMissingEl = null

	for (const marker of markers) {
		if (marker.offsetParent === null) continue

		const field = resolveField(marker)
		if (!field || seen.has(field)) continue
		seen.add(field)

		total += 1
		if (!isFieldAnswered(field)) {
			missing += 1
			if (!firstMissingEl) firstMissingEl = field
		}
	}

	return { total, missing, firstMissingEl }
}

export const scrollToFirstMissingField = container => {
	const { firstMissingEl } = getRequiredFieldStatus(container)
	if (!firstMissingEl) return false

	firstMissingEl.scrollIntoView({ behavior: 'smooth', block: 'center' })
	requestAnimationFrame(() => {
		firstMissingEl.classList.add('field-flash-invalid')
		setTimeout(() => firstMissingEl.classList.remove('field-flash-invalid'), 1300)
	})
	if (typeof firstMissingEl.focus === 'function') {
		try {
			firstMissingEl.focus({ preventScroll: true })
		} catch {
			firstMissingEl.focus()
		}
	}
	return true
}
